import { Checkbox } from '@/components/ui/checkbox.js';
import { useToast } from '@/components/ui/hooks/use-toast.js';
import { updateCoachProfile } from '@/lib/api-calls.js';
import { airServerErrorFrom } from '@/lib/error-handling.js';
import { CoachOnboardingRow, UpdateCoachOptions } from '@airreading/common/data';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type OnboardingStepField = 'documentsReviewPassed' | 'workshopPassed' | 'onboardingTechCheckPassed';

export const OnboardingStepCheckbox = ({ coach, field }: { coach: CoachOnboardingRow; field: OnboardingStepField }) => {
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const { mutateAsync: updateCoachProfileMutate } = useMutation({ mutationFn: updateCoachProfile });

  const checked = coach[field];

  const onChange = async () => {
    try {
      const data: UpdateCoachOptions = { [field]: !checked };
      await updateCoachProfileMutate({
        userId: coach.id,
        data,
      });
      queryClient.invalidateQueries({ queryKey: ['COACHES'] });
    } catch (e) {
      toast({
        title: airServerErrorFrom(e)?.userFacingMessage || 'Failed to update onboarding step',
      });
    }
  };

  return <Checkbox checked={checked} onCheckedChange={() => void onChange()} />;
};
